export interface OrderConversionInput {
  completedOrders: number
  failedOrders: number
  activeOrders: number
}

export interface OrderConversionProjection {
  terminalOrders: number
  historicalCompletionRate: number | null
  historicalReturnRate: number | null
  expectedCompletedFromActive: number | null
  expectedFailedFromActive: number | null
  reason?: string
}

function safeCount(value: number, name: string): number {
  if (!Number.isSafeInteger(value) || value < 0) throw new RangeError(`${name} must be a non-negative safe integer`)
  return value
}

/**
 * Keeps completed outcomes as facts and estimates only the unresolved cohort.
 * The estimate is an operational baseline, not a per-customer prediction.
 */
export function projectActiveOrderOutcomes(input: OrderConversionInput): OrderConversionProjection {
  const completedOrders = safeCount(input.completedOrders, 'completedOrders')
  const failedOrders = safeCount(input.failedOrders, 'failedOrders')
  const activeOrders = safeCount(input.activeOrders, 'activeOrders')
  const terminalOrders = completedOrders + failedOrders
  if (terminalOrders === 0) {
    return {
      terminalOrders,
      historicalCompletionRate: null,
      historicalReturnRate: null,
      expectedCompletedFromActive: null,
      expectedFailedFromActive: null,
      reason: 'Недостаточно завершённых заказов для оценки активных.',
    }
  }
  const historicalCompletionRate = completedOrders / terminalOrders
  const expectedCompletedFromActive = Math.round(activeOrders * historicalCompletionRate)
  return {
    terminalOrders,
    historicalCompletionRate,
    historicalReturnRate: failedOrders / terminalOrders,
    expectedCompletedFromActive,
    // Derive this from the rounded completion estimate to retain cohort conservation.
    expectedFailedFromActive: activeOrders - expectedCompletedFromActive,
  }
}
